import request from "@/service";

/* 查询期刊列表 */
export function periodicalInfoList(data) {
  return request({
    url: `/resource/periodical/info/page`,
    method: "get",
    params: data
  });
}

/* 查询推荐阅读列表 */
export function getArticleList(data) {
  return request({
    url: `/resource/periodical/article/recommend`,
    method: "get",
    params: data
  });
}

/* 新增期刊 */
export function periodicalInfoSave(data) {
  return request({
    url: `/resource/periodical/info/save`,
    method: "post",
    data
  });
}

/* 更新期刊信息 */
export function periodicalInfoUpdate(data) {
  return request({
    url: `/resource/periodical/info/update`,
    method: "put",
    data
  });
}

/* 批量删除期刊 */
export function periodicalInfoDelete(data) {
  return request({
    url: `/resource/periodical/info/delete`,
    method: "delete",
    data
  });
}

/* 上下线 */
export function changeOnlineStatus(data) {
  return request({
    url: `/resource/periodical/info/online`,
    method: "put",
    data
  });
}

/* 获取期刊信息列表 */
export function getList(data) {
  return request({
    url: `/resource/periodical/info/page`,
    method: "get",
    params: data
  });
}

/* 获取期刊详情 */
export function getPeriodicalInfoInfo(data) {
  return request({
    url: `/resource/periodical/info/info/${data.uuid}`,
    method: "get"
  });
}

/* 获取期刊详情 */
export function getNextPeriod(data) {
  return request({
    url: `/resource/periodical/info/nextPeriod/${data}`,
    method: "get"
  });
}

// 共享记录
export function shareList(data) {
  return request({
    url: `/resource/periodical/info/shareList`,
    method: "get",
    params: data
  });
}

// 恢复共享
export function recovery(data) {
  return request({
    url: `/resource/periodical/info/recovery`,
    method: "put",
    data
  });
}

// 共享
export function sharePeriodical(data) {
  return request({
    url: `/resource/periodical/info/share`,
    method: "put",
    data
  });
}

// 取消共享
export function cancelShare(data) {
  return request({
    url: `/resource/periodical/info/cancelShare`,
    method: "put",
    data
  });
}
// 一键共享
export function shareAll(data) {
  return request({
    url: `/resource/periodical/info/shareAll`,
    method: "put",
    data
  });
}
// 期刊统计-概况-jcc
export function periodicaBasic(params) {
  return request({
    url: `/resource/periodical/info/statistic/basic`,
    method: "get",
    params
  });
}

// 期刊统计-学习明细-jcc
export function periodicaLearn(data) {
  return request({
    url: `/resource/periodical/info/statistic/learn`,
    method: "post",
    data
  });
}

// 期刊统计-期刊文章分布-jcc
export function periodicaArticl(params) {
  return request({
    url: `/resource/periodical/info/statistic/article`,
    method: "get",
    params
  });
}

/* 导出期刊统计信息-shijunjian */
export function exportPeriodicalStatisticInfo(data) {
  return request({
    url: `/resource/periodical/info/export`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}
